<template>
  <v-app id="inspire">
    <nav-bar class="no-print"></nav-bar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  import NavBar from './components/NavBar'

  export default {
    name: 'App',
    components:{ NavBar },
    mounted(){
      this.$root.$print = false
    }
  }
</script>

<style>
  @media print
  {
    .no-print, .no-print *
    {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue